import * as React from 'react';

interface ReportPremiumContextType {
  hasSchoolOrDistrictPremium: boolean;
}

const ReportPremiumContext = React.createContext<ReportPremiumContextType | undefined>(undefined);

export const ReportPremiumProvider: React.FC<{ children: React.ReactNode; hasSchoolOrDistrictPremium: boolean }> = ({ children, hasSchoolOrDistrictPremium }) => {
  const value = React.useMemo(() => ({ hasSchoolOrDistrictPremium }), [hasSchoolOrDistrictPremium]);

  return (
    <ReportPremiumContext.Provider value={value}>
      {children}
    </ReportPremiumContext.Provider>
  );
};

export const useReportPremiumContext = (): ReportPremiumContextType => {
  const context = React.useContext(ReportPremiumContext);
  if (context === undefined) {
    throw new Error('useReportPremiumContext must be used within a PremiumProvider');
  }
  return context;
};
